import { createContext, useContext } from 'react';
const absent = {
    enabled: false,
    state: { kind: 'loading' },
    read: null,
    scope: null,
    service: null,
    refetch: async () => null,
    isCurrent: () => false,
};
export const MigrationContext = createContext(absent);
export function useBenefitMigration() {
    return useContext(MigrationContext);
}
